import { Language } from '../../apiTypes';
import { setLanguage } from '../../../resources/strings';
import { getUser } from '../../../localStorageAPI';

export const name = 'user';

export const types = {
    CHANGE_LANGUAGE: `${name}/CHANGE_LANGUAGE`,
};

export interface UserState {
    lang: Language;
}

const initialState: UserState = {
    lang: getUser()?.language || Language.FR,
};

const reducer = (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.CHANGE_LANGUAGE:
            setLanguage(action.payload.lang);
            return {
                ...state,
                lang: action.payload.lang,
            };
        default:
            return state;
    }
};
export default reducer;

// ActionCreators
export const actions = {
    changeLanguage: (lang: Language): any => ({ type: types.CHANGE_LANGUAGE, payload: { lang } }),
};

const localState = (state: any): UserState => state[name] || initialState;
export const selectors = {
    language: (state): string => localState(state).lang,
};
